(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PassengerDetailController', PassengerDetailController);

    PassengerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Passenger', 'Customer', 'TicketPayment'];

    function PassengerDetailController($scope, $rootScope, $stateParams, previousState, entity, Passenger, Customer, TicketPayment) {
        var vm = this;

        vm.passenger = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:passengerUpdate', function(event, result) {
            vm.passenger = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
